import './axios.interceptors'
import './app.scss'
import 'dayjs/locale/fr'
import '@fortawesome/fontawesome-free/css/fontawesome.css'
import '@fortawesome/fontawesome-free/css/brands.css'
import '@fortawesome/fontawesome-free/css/solid.css'

import * as Sentry from '@sentry/vue'
import Vue, { type VNode } from 'vue'
import Croppa from 'vue-croppa'

import App from './App.vue'
import { i18n } from './i18n/i18n'
import vuetify from './plugins/vuetify'
import router from './router'
import ConfirmationModal from './shared/components/global/modals/ConfirmationModal.vue'
import DeletingModal from './shared/components/global/modals/DeletingModal.vue'
import Modal from './shared/components/global/modals/Modal.vue'
import Page from './shared/components/global/Page.vue'
import PreviewSync from './shared/components/preview/PreviewSync.vue'
import store from './store'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['web-mobile-preview', 'chapito-static']

Vue.use(Croppa)

//Global components
Vue.component('Page', Page)
Vue.component('Modal', Modal)
Vue.component('DeletingModal', DeletingModal)
Vue.component('ConfirmationModal', ConfirmationModal)
Vue.component('PreviewSync', PreviewSync)

// Sentry integration, login dev@code-troopers
if (!import.meta.env.DEV) {
  Sentry.init({
    Vue,
    dsn: 'https://c48139fcffa14ba5a9560e8afbf8157c@o100126.ingest.us.sentry.io/1301118',
    // one image serves every client: the host tells them apart (itg, pp, <client>.chapi.to)
    environment: window.location.hostname,
    // set by the CI at the docker build (tag, or commit when untagged)
    release: import.meta.env.VITE_APP_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],

    // 10% of the page loads are traced: performance monitoring without
    // sending a transaction on every page load
    tracesSampleRate: 0.1,

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

new Vue({
  router,
  i18n,
  store,
  vuetify,
  render(h): VNode {
    return h(App)
  },
}).$mount('#app')
